import Cookies from 'js-cookie';

const TOKEN_KEY = 'cookie_auth_token';

/**
 * Sets the authentication token in cookies with no expiration by default.
 * The token will persist across browser sessions unless explicitly removed.
 *
 * @param token - The token string to be stored.
 * @param options - Optional cookie attributes (e.g., expires, path).
 *                 If no expires is provided, the cookie will persist indefinitely.
 */
export const setWebToken = (token: string, options?: Cookies.CookieAttributes): Promise<void> => {
  return new Promise((resolve) => {
    // Default cookie settings without expiration for persistent tokens
    const defaultOptions: Cookies.CookieAttributes = {
      secure: true,
      path: '/',
      sameSite: 'Strict'
    };
    
    // Merge user options with defaults, allowing override of any setting
    const cookieOptions = { ...defaultOptions, ...options };
    
    Cookies.set(TOKEN_KEY, token, cookieOptions);
    resolve();
  });
};

/**
 * Retrieves the authentication token from cookies.
 *
 * @returns The token string if it exists, otherwise undefined.
 */
export const getToken = (): string | undefined => {
  return Cookies.get(TOKEN_KEY);
};

/**
 * Removes the authentication token from cookies.
 *
 * @param options - Optional cookie attributes (e.g., path).
 */
export const removeToken = (options?: Cookies.CookieAttributes): void => {
  Cookies.remove(TOKEN_KEY, {path: '/', sameSite: 'Strict', ...options});
};
